export type AuthSnapshot = {
  id: string
  email: string
  nickname: string
}

type SupabaseUserLike = {
  id: string
  email?: string | null
  user_metadata?: Record<string, unknown> | null
}

export function buildAuthSnapshot(user: SupabaseUserLike | null | undefined): AuthSnapshot | null {
  if (!user) return null
  return {
    id: user.id,
    email: user.email ?? '',
    nickname: typeof user.user_metadata?.nickname === 'string' ? user.user_metadata.nickname : '',
  }
}

export function getAuthDisplayName(snapshot: AuthSnapshot | null) {
  if (!snapshot) return '비회원'
  return snapshot.nickname || snapshot.email || '회원'
}


export type HeaderAuthAction = {
  label: string
  href?: string
  action?: 'logout'
}

export function getHeaderAuthActions(snapshot: AuthSnapshot | null): HeaderAuthAction[] {
  if (!snapshot) return [{ label: '로그인', href: '/admin/login' }]
  return [
    { label: '관리자 대시보드', href: '/admin' },
    { label: '로그아웃', action: 'logout' },
  ]
}
